module.exports = __webpack_public_path__ + "img/712.3fccb42f.png";